export const styles = () => ({
  root: {
    width: "100%",
    padding: 20,
  },
  redButton: {
		backgroundColor: 'rgb(253, 46, 37) !important',
	},
});
